import { Attr, HasMany, Model } from "spraypaint"

import ApplicationRecord from "./applicationRecord/applicationRecord"
import type { Site } from "./site"
import type { UserRoleType } from "./user-role"

export interface UserCreate {
  email: User["email"]
  first_name: User["firstName"]
  last_name: User["lastName"]
  organization_id?: number
  role?: UserRoleType
}

@Model()
export class User extends ApplicationRecord {
  public static readonly jsonapiType = "users"

  @HasMany("sites") public sites!: Site[]

  @Attr() public email!: string

  @Attr() public firstName!: string

  @Attr() public lastName!: string

  @Attr() public name!: string

  @Attr() public phoneNumber!: string

  @Attr() public companyName!: string

  @Attr() public admin!: boolean

  @Attr() public consultantUser!: boolean

  @Attr() public role!: UserRoleType

  @Attr() public title!: string

  @Attr() public organizationIds!: number[]

  @Attr() public limitedAccessOrganizationIds!: number[]
}
